module.exports = __webpack_public_path__ + "static/img/logo10.0bc895d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo10.jpg
// module id = E69H
// module chunks = 1